import React, { Component } from "react";
import aboutus from "../assests/aboutus.jpg";

export default class About extends Component {
  render() {
    return (
      <div id="about">
        <section className="about-section py-5">
          <div className="container">
            {/* Section Heading */}
            <div className="text-center mb-5">
              <h1 className="fw-bold">About Us</h1>
              <p className="text-muted">
                Discover who we are, what drives us, and how we’re transforming ideas into impactful lifestyle and business solutions.
              </p>
            </div>

            {/* About Content */}
            <div className="row align-items-center mb-5">
              <div className="col-lg-6">
                <img
                  src={aboutus}
                  alt="About Us"
                  className="img-fluid rounded shadow-lg"
                />
              </div>

              <div className="col-lg-6">
                <h2 className="fw-bold">Our Vision</h2>
                <p className="lead">
                  We aim to become a one-stop destination for ethnic elegance, modern wear, customized solutions, and personalized services.
                </p>
                <p>
                  From ethnic sarees and handcrafted accessories to corporate gifting and uniforms for hospitals, schools, and hotels — we blend tradition with innovation to serve every individual and institution uniquely.
                </p>
                <a href="#services" className="btn btn-primary mt-3">
                  Explore Our Services
                </a>
              </div>
            </div>

            {/* Meet the Team */}
            <div className="mt-5">
              <h2 className="text-center fw-bold mb-4">Meet Our Team</h2>
              <div className="row text-center">
                <div className="col-md-4">
                  <div className="card shadow-sm border-0">
                    <div className="card-body">
                      <h5 className="text-primary fw-bold">Kavita Singh</h5>
                      <p className="text-muted mb-1">CEO & Founder</p>
                      <p className="small text-muted">Qualification: Master in Business Administration</p>
                    </div>
                  </div>
                </div>

                {/* <div className="col-md-4">
                  <div className="card shadow-sm border-0">
                    <div className="card-body">
                      <h5 className="text-primary fw-bold">Pradeep Rawal</h5>
                      <p className="text-muted mb-1">Operations Head</p>
                      <p className="small text-muted">Qualification: M.Tech in Civil Engineering</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="card shadow-sm border-0">
                    <div className="card-body">
                      <h5 className="text-primary fw-bold">Vishal Kumar</h5>
                      <p className="text-muted mb-1">Technical Head & Transformation</p>
                      <p className="small text-muted">Qualification: B.Tech in Computer Science</p>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

          
          </div>
        </section>
      </div>
    );
  }
}
